import {DatePicker} from 'antd';
import {getPopupContainer} from '../../../Utils/common';
import moment from 'dayjs';

export function FormDataRangePicker({
    value,
    defaultValue,
    onChange,
    ...extraProps
}: any) {
    function getMoment(dateStr: string) {
        const str = dateStr.replaceAll('/', '-');
        const {picker = 'date'} = extraProps;
        if (picker === 'year') return moment(str, 'YYYY');
        return moment(str);
    }

    const innerValue: any | undefined = value
        ? [getMoment(value[0]), getMoment(value[1])]
        : undefined;

    const innerDefaultValue: any | undefined = defaultValue
        ? [getMoment(defaultValue[0]), getMoment(defaultValue[1])]
        : undefined;

    function onValueChange(values: unknown, dateString: [string, string]) {
        if (!values) return onChange?.(undefined);
        onChange?.(dateString);
    }

    return (
        <DatePicker.RangePicker
            {...extraProps}
            value={innerValue}
            defaultValue={innerDefaultValue}
            onChange={onValueChange}
            getPopupContainer={getPopupContainer}
        />
    );
}
